jQuery(document).ready(function() {
  if(window.location.href != "https://roody.co/pages/custom-hawaiian-shirts") {
    if ($(".rte .page-container-jm").length > 0) {
        $('div#shopify-section-header').next().css({'margin-top': '150px'});
    } else {
        $('div#shopify-section-header').next().css({'margin-top': '125px'});
    }
  }
});
jQuery(document).ready(function() {
  document.getElementById('predictive-search-input').addEventListener('keyup', function () {
    const query = this.value;

    if (query.length < 3) {
      document.getElementById('predictive-search-results').innerHTML = '';
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
      .then(response => response.json())
      .then(data => {
        const resultsContainer = document.getElementById('predictive-search-results');
        resultsContainer.innerHTML = '';

        if (data.resources.results.products.length) {
          // Filter out products with "Sample" in the title
          const filteredProducts = data.resources.results.products.filter(product => 
            !product.title.toLowerCase().includes('sample')
          );

          if (filteredProducts.length) {
            filteredProducts.forEach(product => {
              const item = document.createElement('div');
              item.className = 'search-result-item';
              item.innerHTML = `
                <a href="${product.url}">
                  <img src="${product.image}" alt="${product.title}" />
                  <span>${product.title}</span> &nbsp;-&nbsp; <span>$${product.price}</span>
                </a>
              `;
              resultsContainer.appendChild(item);
            });
          } else {
            resultsContainer.innerHTML = '<p>No results found</p>';
          }
        } else {
          resultsContainer.innerHTML = '<p>No results found</p>';
        }
      });
  });

  $('#predictive-search-input').on('input', function() {
    if ($(this).val().trim() === "") {
      $('#predictive-search-results').css("display", "none");
    } else {
      $('#predictive-search-results').css("display", "block");
    }
  });
});



jQuery(document).ready(function() {
  document.getElementById('predictive-search-input-mobile').addEventListener('keyup', function () {
    const query = this.value;

    if (query.length < 3) {
      document.getElementById('predictive-search-results').innerHTML = '';
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
      .then(response => response.json())
      .then(data => {
        const resultsContainer = document.getElementById('predictive-search-results-mobile');
        resultsContainer.innerHTML = '';

        if (data.resources.results.products.length) {
          // Filter out products with "Sample" in the title
          const filteredProducts = data.resources.results.products.filter(product => 
            !product.title.toLowerCase().includes('sample')
          );

          if (filteredProducts.length) {
            filteredProducts.forEach(product => {
              const item = document.createElement('div');
              item.className = 'search-result-item';
              item.innerHTML = `
                <a href="${product.url}">
                  <img src="${product.image}" alt="${product.title}" />
                  <span>${product.title}</span> &nbsp;-&nbsp; <span>$${product.price}</span>
                </a>
              `;
              resultsContainer.appendChild(item);
            });
          } else {
            resultsContainer.innerHTML = '<p>No results found</p>';
          }
        } else {
          resultsContainer.innerHTML = '<p>No results found</p>';
        }
      });
  });

  $('#predictive-search-input-mobile').on('input', function() {
    if ($(this).val().trim() === "") {
      $('#predictive-search-results-mobile').css("display", "none");
    } else {
      $('#predictive-search-results-mobile').css("display", "block");
    }
  });
});


jQuery(document).ready(function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
        panel.classList.remove("active-panel");
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.classList.add("active-panel");
      } 
    }
  }
});

/*Case Study List Page */
  $(document).ready(function() {
    $('.bar-input').on('keyup', function() {
      var searchTerm = $(this).val().toLowerCase();

      $('.case-study-list ul li').each(function() {
        var text = $(this).text().toLowerCase();
        $(this).toggle(text.includes(searchTerm));
      });
    });
  });

/*Update '€', '$' on PDP */
$(document).ready(function() {
  $('.single-product .prod-cont-wrap .prod-info td').each(function() {
    var text = $(this).text();
    if (text.includes('€')) {
      $(this).text(text.replace('€', '$'));
    }
  });
});

/*Update cart quantity to 50*/
/*$(document).ready(function() {
    // --- Quantity Change Handler ---
    $('.cart__qty input').on('change', function() {
        var $input = $(this);
        var newQuantity = parseInt($input.val(), 10);

        // Get line item key from input ID
        var nameAttr = $input.attr('id') || '';
        var matches = nameAttr.match(/updates_(.+)/);

        if (!matches || matches.length < 2) {
            console.error('Could not find line item key for cart update');
            return;
        }

        var lineItemKey = matches[1]; // Extracted key

        // Shopify AJAX Cart Update
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                quantity: newQuantity,
                id: lineItemKey
            },
            dataType: 'json',
            success: function(cart) {
                console.log('Cart updated:', cart);

                // Loop through cart items and update corresponding DOM prices
                cart.items.forEach(function(item) {
                    var unitPrice = item.price / 100;
                    var itemTotal = (unitPrice * item.quantity).toFixed(2);

                    // Find the correct input by matching item.key in input id attribute
                    var $matchingInput = $('.cart__qty input[id^="updates_' + item.key + '"]');

                    if ($matchingInput.length > 0) {
                        var $parentRow = $matchingInput.closest('tr');

                        // Update the item total price display for this product line
                        $parentRow.find('div[data-cart-item-regular-price-group] span[data-cart-item-regular-price]').text('€' + itemTotal);

                        // If applicable, update final price display as well
                        $parentRow.find('span[data-cart-item-final-price]').text('€' + itemTotal);
                    }
                });

                // Update the cart subtotal in the DOM
                var subtotal = cart.total_price / 100;
                $('span.cart-subtotal__price[data-cart-subtotal]').text('€' + subtotal.toFixed(2) + ' EUR');
            },
            error: function(err) {
                console.error('Failed to update cart:', err);
            }
        });
    });

    // --- Auto Update Quantity Based on Product Title ---
    var $qtyInput = $('.cart__qty input');

    $qtyInput.each(function() {
        var $input = $(this);

        // Find the product title link in the same row
        var $titleLink = $input.closest('tr').find('.list-view-item__title a');
        if ($titleLink.length === 0) {
            $titleLink = $input.closest('td').siblings().find('.list-view-item__title a');
        }

        var productTitle = $titleLink.text().trim();

        // Determine quantity based on product title
        var desiredQuantity = (productTitle !== 'Sample Polo Shirt') ? 100 : 50;

        // Update input and trigger change event
        $input.prop('disabled', false).val(desiredQuantity).trigger('change');
    });
});*/

//Zakeke button on PDP
 $(document).ready(function() {
    $('button.zakeke-product-button.btn.button').insertAfter(".product-single__meta .button-wrapper");
 });

//Redirect customer account to customer portal page 6-4-2025
 if (window.location.pathname === '/account' || window.location.pathname === '/account/') {
    window.location.href = '/pages/customer-order-portal';
  }

//Redirect register page to customer account if customer is login already 6-4-2025
$(document).ready(function() {
  var inputVal = $('#customer_value_checker').val();
  var isRegisterPage = window.location.pathname === '/account/register';

  if (inputVal && isRegisterPage) {
    window.location.href = '/account'; // Redirect to account page
  }
});